import dotProp from 'dot-prop-immutable';
import * as types from 'live/redux/actionTypes';

import {
  LIVE_CHAT_MESSAGE,
  LIVE_CHAT_MESSAGE_DELETE,
  LIVE_CHAT_MESSAGE_UPDATE,
} from 'shared/constants/StompKind';
import { STOMP_RECEIVE_DATA } from 'shared/redux/actionTypes';

const defaultState = {
  list: {
    error: undefined,
    loading: false,
    messages: [],
    totalPages: 0,
  },
  message: {
    error: undefined,
    loading: false,
    text: '',
  },
  page: 0,
  recentUsers: [],
};

export default function reducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.LIVE_CHAT_SET_PAGE: {
      return dotProp.set(state, 'page', action.payload);
    }

    // load messages

    case types.LIVE_CHAT_REQUEST: {
      return dotProp.set(state, 'list', {
        ...state.list,
        error: undefined,
        loading: true,
      });
    }

    case types.LIVE_CHAT_RECEIVE: {
      const { content, totalPages } = action.payload;
      const { page } = action.meta;
      const messages =
        page === 0 ? content : [...state.list.messages, ...content];
      const ids = messages.map(o => o.id);
      const filtered = messages.filter(({ id }, i) => !ids.includes(id, i + 1));

      return dotProp.set(state, 'list', {
        ...defaultState.list,
        messages: filtered,
        totalPages,
      });
    }

    case types.LIVE_CHAT_ERROR: {
      const error = action.payload;

      return dotProp.set(state, 'list', {
        ...defaultState.list,
        error: error.message,
      });
    }

    // load users

    case types.LIVE_CHAT_USERS_RECEIVE: {
      const recentUsers = action.payload;

      return dotProp.set(state, 'recentUsers', recentUsers);
    }

    // set editing message

    case types.LIVE_CHAT_MESSAGE_EDIT: {
      const { id, edit = true, text = '' } = action.payload;

      if (id) {
        const index = state.list.messages.findIndex(m => m.id === id);

        return dotProp.set(state, `list.messages.${index}.edit`, edit);
      }

      return dotProp.set(state, 'message.text', text);
    }

    // send message

    case types.LIVE_CHAT_MESSAGE_REQUEST: {
      const { id } = action.meta;

      if (!id) {
        return dotProp.set(state, 'message.loading', true);
      }

      const { messages } = state.list;
      const index = messages.findIndex(m => m.id === id);

      return dotProp.set(state, `list.messages.${index}.loading`, true);
    }

    case types.LIVE_CHAT_MESSAGE_RECEIVE: {
      const { id } = action.meta;

      if (!id) {
        return dotProp.set(state, 'message', defaultState.message);
      }

      const { messages } = state.list;
      const index = messages.findIndex(m => m.id === id);

      return dotProp.set(state, `list.messages.${index}.loading`, false);
    }

    case types.LIVE_CHAT_MESSAGE_ERROR: {
      const { id } = action.meta;
      const error = action.payload;

      if (!id) {
        return dotProp.set(state, 'message', {
          ...state.message,
          loading: false,
          error: error?.response?.message ?? error.message,
        });
      }

      const { messages } = state.list;
      const index = messages.findIndex(m => m.id === id);

      return dotProp.set(state, `list.messages.${index}.error`, error.message);
    }

    // (dis)like message

    case types.LIVE_CHAT_MESSAGE_RATE_REQUEST: {
      const { id } = action.meta;
      const { messages } = state.list;
      const index = messages.findIndex(m => m.id === id);

      return dotProp.set(state, `list.messages.${index}.loading`, true);
    }

    case types.LIVE_CHAT_MESSAGE_RATE_RECEIVE: {
      const { id, like } = action.meta;
      const { changeMind, success } = action.payload;
      const { messages } = state.list;
      const index = messages.findIndex(m => m.id === id);

      if (!success) {
        return dotProp.set(state, `list.messages.${index}.loading`, false);
      }

      const message = messages.find(m => m.id === id);
      const type = like ? 'likeCount' : 'dislikeCount';
      const typePrev = !like ? 'likeCount' : 'dislikeCount';

      return dotProp.set(state, `list.messages.${index}`, {
        ...message,
        loading: false,
        [type]: message[type] + 1,
        [typePrev]: changeMind ? message[typePrev] - 1 : message[typePrev],
      });
    }

    case types.LIVE_CHAT_MESSAGE_RATE_ERROR: {
      const { id } = action.meta;
      const { messages } = state.list;
      const index = messages.findIndex(m => m.id === id);

      return dotProp.set(state, `list.messages.${index}.loading`, false);
    }

    case STOMP_RECEIVE_DATA: {
      const { kind, data } = action.payload;
      const { id, message, recentUsers, text } = data;

      // update message

      if (kind === LIVE_CHAT_MESSAGE_UPDATE && text && id) {
        const { messages } = state.list;
        const index = messages.findIndex(m => m.id === id);

        return dotProp.set(state, `list.messages.${index}`, {
          ...messages[index],
          loading: false,
          edit: false,
          text,
        });
      }

      // delete messages

      if (kind === LIVE_CHAT_MESSAGE_DELETE && id) {
        const { messages } = state.list;
        const page = Math.floor(messages.length / 3);

        return {
          ...state,
          page,
          list: {
            ...state.list,
            messages: messages.filter(m => m.id !== id),
          },
        };
      }

      // receive new message

      if (kind === LIVE_CHAT_MESSAGE && message) {
        const messages = [...state.list.messages, message].sort(
          (a, b) => b.id - a.id,
        );
        const page = Math.floor(messages.length / 3);

        return {
          ...state,
          page,
          list: {
            ...state.list,
            messages,
          },
          recentUsers: recentUsers || state.recentUsers,
        };
      }

      return state;
    }

    default:
      return state;
  }
}
